import EventEmitter from 'events';

const eventPrifix = 'videosdk-live-react-sdk';

const events = {
  'participant-joined': `${eventPrifix}-participant-joined`,
  'participant-left': `${eventPrifix}-participant-left`,
  'speaker-changed': `${eventPrifix}-speaker-changed`,
  'presenter-changed': `${eventPrifix}-presenter-changed`,
  'main-participant-changed': `${eventPrifix}-main-participant-changed`,
  'entry-requested': `${eventPrifix}-entry-requested`,
  'entry-responded': `${eventPrifix}-entry-responded`,
  'recording-started': `${eventPrifix}-recording-started`,
  'recording-stopped': `${eventPrifix}-recording-stopped`,
  data: `${eventPrifix}-data`,
  'meeting-joined': `${eventPrifix}-meeting-joined`,
  'meeting-left': `${eventPrifix}-meeting-left`,
  'live-stream-started': `${eventPrifix}-live-stream-started`,
  'live-stream-stopped': `${eventPrifix}-live-stream-stopped`,
  'video-state-changed': `${eventPrifix}-video-state-changed`,
  'video-seeked': `${eventPrifix}-video-seeked`,
  'webcam-requested': `${eventPrifix}-webcam-requested`,
  'mic-requested': `${eventPrifix}-mic-requested`,
  'pin-state-changed': `${eventPrifix}-pin-state-changed`,
  'connection-open': `${eventPrifix}-connection-open`,
  'connection-close': `${eventPrifix}-connection-close`,
  'switch-meeting': `${eventPrifix}-switch-meeting`,
  error: `${eventPrifix}-error`,
  'hls-started': `${eventPrifix}-hls-started`,
  'hls-stopped': `${eventPrifix}-hls-stopped`,
  'hls-state-changed': `${eventPrifix}-hls-state-changed`,
  'hls-playable-state-changed': `${eventPrifix}-hls-playable-state-changed`,
  'recording-state-changed': `${eventPrifix}-recording-state-changed`,
  'livestream-state-changed': `${eventPrifix}-livestream-state-changed`,
  'meeting-state-changed': `${eventPrifix}-meeting-state-changed`,
  'participant-mode-changed': `${eventPrifix}-participant-mode-changed`,
  'transcription-state-changed': `${eventPrifix}-transcription-state-changed`,
  'transcription-text': `${eventPrifix}-transcription-text`,
  'translation-state-changed': `${eventPrifix}-translation-state-changed`,
  'translation-language-changed': `${eventPrifix}-translation-language-changed`,
  'translation-text': `${eventPrifix}-translation-text`,
  'character-joined': `${eventPrifix}-character-joined`,
  'character-left': `${eventPrifix}-character-left`,
  'whiteboard-started': `${eventPrifix}-whiteboard-started`,
  'whiteboard-stopped': `${eventPrifix}-whiteboard-stopped`,
  'paused-all-streams': `${eventPrifix}-paused-all-streams`,
  'resumed-all-streams': `${eventPrifix}-resumed-all-streams`,
  'media-relay-started': `${eventPrifix}-media-relay-started`,
  'media-relay-stopped': `${eventPrifix}-media-relay-stopped`,
  'media-relay-error': `${eventPrifix}-media-relay-error`,
  'media-relay-request-response': `${eventPrifix}-media-relay-request-response`,
  'media-relay-request-received': `${eventPrifix}-media-relay-request-received`,
  'quality-limitation': `${eventPrifix}-quality-limitation`
};

const eventEmitter = new EventEmitter();
eventEmitter.setMaxListeners(9999);

function debounce(func, delay) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

export { eventEmitter, events, debounce };
